import { Component } from '@angular/core'
import { Auth, signInWithEmailAndPassword } from '@angular/fire/auth'
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms'
import { Router } from '@angular/router'

@Component({
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent {
  constructor(private auth: Auth, private router: Router) {}

  loginGroup = new UntypedFormGroup({
    username: new UntypedFormControl(null, Validators.email),
    password: new UntypedFormControl(null, Validators.minLength(4)),
  })

  loading = false
  logginError = ''

  async submit() {
    const creds = this.loginGroup.value
    this.loading = true
    try {
      await signInWithEmailAndPassword(this.auth, creds.username, creds.password)
      this.router.navigate(['/'])
    } catch (e) {
      console.log(e)
      this.logginError = 'Hibás bejelentkezési adatok!'
    } finally {
      this.loading = false
    }
  }
}
